import { MenuProps } from "antd"
import { useDeleteCategoryStore } from "store/configuration.store"
import { DeleteIcon } from "components/ui/icons/delete/DeleteIcon"
import type { ICategoryDimensions } from "types/configuration.type"
import style from "./Categories.module.scss"

const { editModelNumbers, deleteProtectionMessage, inactiveDeleteBlock, deleteBlock, deleteIcon } = style

type DropDownItem = {
	deletable: boolean
	modelNumbers: string[]
	objectName: string
	categoryId: number
	deletionProtectionReason: string
	name: string
	preDeleteMessage: string
	dimensions: ICategoryDimensions
}

export const CategoriesUtils = () => {
	const { setDeleteCategoryModalOpen, setDeleteCategoryData } = useDeleteCategoryStore()

	const getDropDownItems = (item: DropDownItem) => {
		const objectDeletable = item.deletable

		const items: MenuProps["items"] = []

		if (!objectDeletable) {
			items.push({
				key: "2",
				disabled: true,
				label: (
					<div className={inactiveDeleteBlock}>
						<div className={deleteBlock}>
							<DeleteIcon dsiabled />
							<span>Delete</span>
						</div>
						<span className={deleteProtectionMessage}>{item.deletionProtectionReason}</span>
					</div>
				),
			})
		}

		if (objectDeletable) {
			items.push({
				key: "1",
				danger: true,
				disabled: !objectDeletable ? true : false,
				label: (
					<div className={editModelNumbers}>
						<DeleteIcon className={deleteIcon} />
						<span>Delete</span>
					</div>
				),
				onClick: () => {
					setDeleteCategoryModalOpen()
					setDeleteCategoryData({
						categoryName: item.name,
						deletionWarningText: item.preDeleteMessage,
						categoryId: item.categoryId,
					})
				},
			})
		}

		return items
	}

	return { getDropDownItems }
}
